import { Flex } from "@simplybusiness/mobius";
import { useSnowplowContext } from "@simplybusiness/services";
import { useAtom } from "jotai";
import { useCallback } from "react";
import { sliderStateAtom } from "../../../../store";
import { InfoModal } from "../InfoModal";

export type CoverLimitProps = {
  product?: string;
  title: string;
  amount: string;
  explainer?: string;
  withModal?: boolean;
  isCoreCover?: boolean;
};

export const CoverLimit = ({
  product,
  title,
  amount,
  explainer,
  withModal,
  isCoreCover,
}: CoverLimitProps) => {
  const { snowplow } = useSnowplowContext();
  const [sliderIsOpen] = useAtom(sliderStateAtom);

  const handleOpen = useCallback(() => {
    const category = `${
      sliderIsOpen ? "quote_details_slider" : "qcp"
    }_coverage_selection`;

    snowplow?.trigger("coverageModalOpened", { category, product, title });
  }, [sliderIsOpen, snowplow, product, title]);

  const modalTitle = (
    <>
      {title}
      <br />
      {amount}
    </>
  );

  return (
    <Flex
      justifyContent="space-between"
      gap="xs"
      className={isCoreCover ? "" : "mobius-quote-card__cover"}
      flexGrow={1}
    >
      {explainer && withModal ? (
        <InfoModal
          toggleText={title}
          title={modalTitle}
          body={explainer}
          onOpen={handleOpen}
          isCoreCover={isCoreCover}
        />
      ) : (
        title
      )}
      <strong className={isCoreCover ? "" : "mobius-quote-card__cover-amount"}>
        {amount}
      </strong>
    </Flex>
  );
};
